import React, { useState } from 'react';
import { Button, Modal } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';

function ConfirmationModal() {
  const [show, setShow] = useState(false);
  const { t } = useTranslation('common');
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  return (
    <>
      <Button variant="primary" onClick={handleShow}>
        {t('CONFIRMATION_MODAL.CONFIRM_MODAL')}
      </Button>

      <Modal className="custom-modal modal-small" show={show} onHide={handleClose} backdrop="static" keyboard={false}>
        <Modal.Header>
          <Modal.Title>{t('CONFIRMATION_MODAL.CONFIRM_TITLE')}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p>{t('CONFIRMATION_MODAL.CONFIRM_MESSAGE')}</p>
          <div className="modal-buttons mt-5 d-flex justify-content-between">
            <button className="btn btn-default">{t('CONFIRMATION_MODAL.NO')}</button>
            <button className="btn btn-default">{t('CONFIRMATION_MODAL.YES')}</button>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
}

export default ConfirmationModal;
